import { Fragment } from 'react';
import uuid from 'uuid';

const HasLabel = Component =>
  function HasLabel({
    label,
    labelStaticClass = 'input__label',
    labelClassName,
    ...rest
  }) {
    const id = uuid();

    return (
      <Fragment>
        <label className={cx(labelStaticClass, labelClassName)} htmlFor={id}>
          {label}
        </label>
        <Component id={id} {...rest} />
      </Fragment>
    );
  };

export default HasLabel;
